class EvayongSignup extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.dialog = this.querySelector('dialog');
    const options = { signal: this.controller.signal };
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-ey-signup-open]');
      if (!opener) return;
      event.preventDefault();
      this.opener = opener;
      this.open();
    }, options);
    this.addEventListener('click', event => {
      if (event.target.closest('[data-ey-signup-close]')) this.dialog.close();
      if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }
    }, options);
    this.dialog.addEventListener('close', () => {
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('evayong:signup-closed'));
    }, options);
    if (this.querySelector('[data-ey-signup-result]') || new URLSearchParams(location.search).has('signup')) this.open();
  }
  open() {
    if (!this.dialog.open) this.dialog.showModal();
    this.dialog.querySelector('[data-ey-signup-name]')?.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('evayong:signup-opened'));
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('evayong-signup')) customElements.define('evayong-signup', EvayongSignup);
